export default function formatString(value) {
    if (!value) return ''
    if(value.length>25) {
        let start = 0;
        let detail = '';
        for(start=0;start<=value.length;start=start+25) {
            detail = detail + '\n' + value.trim().substring(start, start + 25)
        }
        return detail;
    }
    return value
}